import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/utils/loading/loading.service';
import { AcordarUtils } from 'src/app/utils/acordar/utils.acordar';
import { AcordarService } from 'src/app/services/acordar.service';
import { ProvincesSvgService } from 'src/app/services/provinces-svg.service';

@Component({
	selector: 'app-solicitud-ofertas',
	templateUrl: './solicitud-ofertas.component.html',
	styleUrls: [ './solicitud-ofertas.component.scss' ]
})
export class SolicitudOfertasComponent implements OnInit {
	provincias = this._provincesSVGService.provinces_svg;
	provinciasConOfertas = [];
	constructor(
		private _router: Router,
		private AcordarService: AcordarService,
		private _provincesSVGService: ProvincesSvgService,
		private loadingService: LoadingService
	) {}

	ngOnInit() {
		this.loadingService.show();
		this.AcordarService.getProvinciasConOfertas().subscribe(
			(rta) => {
				this.loadingService.hide();
				this.provinciasConOfertas = rta.map((r) => r.descripcion.toUpperCase());
			},
			(error) => {
				this.loadingService.hide();
				console.error('Error on call to server');
			}
		);
	}

	toUpper(str) {
		return AcordarUtils.capitalizeLetter(str);
	}

	clickProvincia(idProvincia) {
		let provs = this.provinciasConOfertas.map((prov) => prov.toUpperCase());
		if (idProvincia !== null && provs.includes(idProvincia.toUpperCase())) {
			this._router.navigate([ 'acuerdos-nacionales/provincia/', idProvincia ]);
		} else if (idProvincia === null) {
			this._router.navigate([ 'acuerdos-nacionales/provincias' ]);
		}
	}
}
